import React from "react";
interface TextAreaProps {
  id:string;
  name:string;
  value: string;
  onChange: any;
  placeholder: string;
  className: string;
  rows: number;
  required: boolean;
}

const TextArea: React.FC<TextAreaProps> = ({
  value,
  onChange,
  placeholder,
  className,
  rows,
  required,
}) => {
  return (
    <textarea
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
      rows={rows}
      required={required}
    />
  );
};

export default TextArea;
